/**
 * 资源收藏的通用逻辑: 资源列表页 / 收藏页共用.
 *
 * 用对象展开混进页面组件: { ...courseFavorites(), ...页面自己的状态 }
 * 方法里的 this 指向合并后的组件, 所以能读到页面自己的 courses 等字段。
 */

import { toast } from '../stores/toast'
import type { Course } from '../types/api'
import { ApiError, api } from './api'

export function courseFavorites() {
  return {
    savedCourseIds: [] as number[],

    isCourseSaved(id: number): boolean {
      return this.savedCourseIds.includes(id)
    },

    /** 拉取已收藏的资源 id; 失败退化成「都没收藏」, 不阻塞页面 */
    async loadSavedCourseIds(): Promise<void> {
      try {
        this.savedCourseIds = await api.favorites.savedIds('course')
      } catch {
        this.savedCourseIds = []
      }
    },

    /** 点书签切换收藏; 先乐观更新, 失败回滚 */
    async toggleCourseSave(course: Course): Promise<void> {
      const wasSaved = this.isCourseSaved(course.id)

      this.savedCourseIds = wasSaved
        ? this.savedCourseIds.filter((id) => id !== course.id)
        : [...this.savedCourseIds, course.id]

      try {
        if (wasSaved) {
          await api.favorites.remove('course', course.id)
        } else {
          await api.favorites.add('course', course.id)
        }
        toast(wasSaved ? '已取消收藏' : '已收藏')
      } catch (error) {
        this.savedCourseIds = wasSaved
          ? [...this.savedCourseIds, course.id]
          : this.savedCourseIds.filter((id) => id !== course.id)
        toast(error instanceof ApiError ? error.message : '操作失败, 请重试')
      }
    },
  }
}
